import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

const initialState = {
  id: 0,
  category: "",
  title: "",
};

const DropdownForm = ({ onSave, initialData, readOnly, loading, setLoading }) => {
  const [dropdown, setDropdown] = useState(initialState);

  useEffect(() => {
    if (initialData) {
      setDropdown({ ...initialData });
    } else {
      setDropdown(initialState);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDropdown((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    onSave(dropdown);
    setTimeout(() => {
      setLoading(false);
    }, 2000)

  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="category">
            <Form.Label>
              Category <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Select
              name="category"
              value={dropdown.category || ""}
              onChange={handleChange}
              disabled={readOnly}
            >
              <option value="">Select Category</option>
              <option value="Location">Location</option>
              <option value="HealthCare Category">Health Care Category</option>
              <option value="Community Category">Community Category</option>

            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="title">
            <Form.Label>
              Title <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={dropdown.title}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      {!readOnly && (
        <Row>
          <Col>
            <div className="form-buttons">
              <Button type="submit" className="me-2"
                disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </Button>
              <Button
                variant="secondary"
                onClick={() => setDropdown(initialState)}
              >
                Clear
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default DropdownForm;
